import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file RcDialog.tsx
 * @author markJia(markjia@tencent.com)
 */
import React, { useMemo } from 'react';
import { getZIndex } from '@tencent/glue-dom-helper';
import { Portal } from './Portal';
import { RcMask } from './RcMask';
export var RcDialogHorizontalType;

(function (RcDialogHorizontalType) {
  RcDialogHorizontalType["LEFT"] = "left";
  RcDialogHorizontalType["CENTER"] = "center";
  RcDialogHorizontalType["RIGHT"] = "right";
})(RcDialogHorizontalType || (RcDialogHorizontalType = {}));

export var RcDialogVerticalType;

(function (RcDialogVerticalType) {
  RcDialogVerticalType["TOP"] = "top";
  RcDialogVerticalType["MIDDLE"] = "middle";
  RcDialogVerticalType["BOTTOM"] = "bottom";
})(RcDialogVerticalType || (RcDialogVerticalType = {}));

var getDialogPosition = function getDialogPosition(horizontal, vertical) {
  var style = {
    position: 'absolute',
    zIndex: 2,
    boxShadow: '0 0 10px 3px rgb(0 0 0 / 10%)'
  };

  switch (horizontal.horizontal) {
    case RcDialogHorizontalType.LEFT:
      {
        style.left = horizontal.left;
        break;
      }

    case RcDialogHorizontalType.CENTER:
      {
        style.left = '50%';
        style.transform = 'translateX(-50%)';
        break;
      }

    case RcDialogHorizontalType.RIGHT:
      {
        style.right = horizontal.right;
        break;
      }
  }

  switch (vertical.vertical) {
    case RcDialogVerticalType.TOP:
      {
        style.top = vertical.top;
        break;
      }

    case RcDialogVerticalType.MIDDLE:
      {
        style.top = '50%';
        style.transform = "".concat(style.transform || '', " translateY(-50%)");
        break;
      }

    case RcDialogVerticalType.BOTTOM:
      {
        style.bottom = vertical.bottom;
        break;
      }
  }

  return style;
};

var defaultDialogStyle = {
  position: 'fixed',
  left: 0,
  top: 0,
  bottom: 0,
  right: 0
};
/**
 * RcDialog
 * 1. zIndex 控制
 * 2. 弹框位置：上、下、左、右（例如 右侧弹出， 距顶部10px等）
 * 3. getContainer
 */

export var RcDialog = function RcDialog(props) {
  var show = props.show,
      mask = props.mask,
      vertical = props.vertical,
      horizontal = props.horizontal,
      zIndex = props.zIndex,
      children = props.children,
      className = props.className,
      style = props.style,
      maskClick = props.maskClick,
      getContainer = props.getContainer,
      maskClassName = props.maskClassName,
      maskStyle = props.maskStyle;
  var dialogPosition = useMemo(function () {
    return getDialogPosition(horizontal, vertical);
  }, [horizontal, vertical]);
  var dialogZIndex = useMemo(function () {
    return zIndex !== null && zIndex !== void 0 ? zIndex : getZIndex();
  }, [zIndex, show]);
  var dialogStyle = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, defaultDialogStyle), style), {}, {
      display: show ? 'block' : 'none',
      zIndex: dialogZIndex
    });
  }, [style, show, dialogZIndex]);
  return React.createElement(Portal, {
    getContainer: getContainer
  }, React.createElement("div", {
    className: className,
    style: dialogStyle
  }, mask && React.createElement(RcMask, {
    show: show,
    className: maskClassName,
    style: _objectSpread(_objectSpread({}, maskStyle), {}, {
      zIndex: 1
    }),
    onClick: maskClick
  }), React.createElement("div", {
    style: dialogPosition
  }, children)));
};